import { Controller } from 'react-hook-form';

import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import classes from './SelectInput.module.scss';

const SelectInput = ({
	optionsNameKey,
	optionsIdKey = 'id',
	validation,
	input,
	errors,
	control,
	className = '',
	options = [],
	defaultValue = '',
	placeholder = '',
	horizontal = false,
	showError = true,
	optionsType = 'object',
	...props
}) => {
	return (
		<Box sx={{ minWidth: 120 }} className={classes['select-input-wrapper']}>
			<FormControl
				fullWidth
				error={errors[input.name]}
				{...props}
				className={`row ${horizontal ? 'row d-flex flex-row' : 'd-flex flex-column'}`}>
				<label htmlFor={input.id} className={`${horizontal ? 'col-12 col-xl-4' : ''}`}>
					{input.label}
				</label>
				<Controller
					render={({ field }) => (
						<Select
							{...field}
							labelId={input.id}
							defaultValue={defaultValue}
							className={`${className} ${!field.value && classes['placeholder']} ${horizontal ? 'col-12 col-xl-8' : ''
								} ${classes['select-mui-wrapper']} ${errors[input.name] && classes['select-error']}`}
							inputProps={{
								id: input.id
							}}
							style={{ '--custom-content': `'${placeholder}` }}
							data-testid={`select-${input.name}`}>
							{options.map((opt) => (
								optionsType === 'object' ? (
									<MenuItem value={opt[optionsIdKey]} key={opt[optionsIdKey]}>
										{optionsNameKey ? opt[optionsNameKey] : opt.name}
									</MenuItem>
								) : (
									<MenuItem value={opt} key={opt}>
										{opt}
									</MenuItem>
								)
							))}
						</Select>
					)}
					name={input.name}
					control={control}
					rules={validation}
					defaultValue={defaultValue}
				/>
			</FormControl>
			{showError && errors[input.name] && (
				<p className={classes['validation']}>*This field is required</p>
			)}
		</Box>
	);
};

export default SelectInput;
